document.addEventListener("turbolinks:load", () => {
  $("[id$=scenario_id]").select2();

  $(".add-scenario_group-form").on("cocoon:after-insert", function (e, insertedItem, originalEvent) {
    $(insertedItem).find("[id$=scenario_id]").select2();
  });
});
